import LogRocket from 'logrocket';

// src/onSessionUrlInitialized.ts
function onSessionUrlInitialized(callback) {
  LogRocket.getSessionURL(async (sessionUrl) => {
    await callback(sessionUrl);
  });
}

export { onSessionUrlInitialized };
